// Fonction pour ouvrir le toaster avec du contenu HTML dynamique
window.openToaster = function(htmlContent) {

    var $toaster = $("#myToaster");
    var $toasterMessage = $("#toasterMessage");

    // Si le toaster est déjà visible, retirer temporairement la classe 'show' pour rejouer l'animation
    if ($toaster.hasClass('show')) {
        $toaster.removeClass('show');

        // Utiliser un léger délai avant de réappliquer la classe 'show' pour forcer la transition à se rejouer
        setTimeout(function() {
            // Mettre à jour le contenu HTML du toaster
            $toasterMessage.html(document.getElementById(htmlContent).innerHTML);

            // Réappliquer la classe 'show' après un court instant
            $toaster.addClass('show');
        }, 140); // Un petit délai de 80ms pour laisser le temps à l'animation de se réinitialiser
    } else {
        // Mettre à jour le contenu HTML du toaster
        $toasterMessage.html(document.getElementById(htmlContent).innerHTML);

        // Affiche le toaster avec l'animation
        $toaster.addClass('show');
    }

    // Ajoute un écouteur pour fermer le toaster en cliquant ailleurs sur la page
    $(document).on('click.closeToaster', function(event) {
        if (!$toaster.is(event.target) && $toaster.has(event.target).length === 0) {
            window.closeToaster();
        }
    });
};

// Fonction pour fermer le toaster
window.closeToaster = function() {
    $("#myToaster").removeClass("show");

    // Retire l'écouteur de fermeture lorsque le toaster est fermé
    $(document).off('click.closeToaster');
};

// Empêche la fermeture du toaster quand on clique sur le bouton qui l'ouvre
$(document).on('click', '.open-toaster-btn', function(event) {
    event.stopPropagation(); // Empêche la propagation du clic au document
});
